import i18n from "config/i18next";

i18n.addResources("es", "requirements", {
  title: "¿Qué es pickers?",
  secondTitle: "¿Qué necesitas para ser picker?",
  description: "Somos un servicio de distribución de paquetes pequeños de e-commerce que te permite aumentar tus ingresos.\n Retirás el paquete, lo entregás y ¡listo!\nVas a distribuir los pedidos de lunes a viernes, desde la mañana hasta la tarde, seleccionando tus zonas cercanas desde la app.\n Además, contás con el equipo de soporte, quien se encuentra disponible para ayudarte cuando lo necesites.",
  requirements: [
    "Ser mayor de 18 años",
    "Documento nacional de identidad (DNI)",
		"Constancia de inscripción al monotributo",
		"Cuenta bancaria y el comprobante de CBU (propia)",
		"Bici o moto con su documentación correspondiente"
  ],
});
